import { render, staticRenderFns } from "./AccountDetails.vue?vue&type=template&id=3d9bbdb2"
import script from "./AccountDetails.vue?vue&type=script&lang=js"
export * from "./AccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports